import { render, staticRenderFns } from "./eventActivities.vue?vue&type=template&id=36e1d229&scoped=true&"
import script from "./eventActivities.vue?vue&type=script&lang=js&"
export * from "./eventActivities.vue?vue&type=script&lang=js&"
import style0 from "./eventActivities.vue?vue&type=style&index=0&id=36e1d229&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1d229",
  null
  
)

export default component.exports